import { Box, Button, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import HumbeeLogo from '../TopNav/HumbeeLogo'
import { useNavigate } from 'react-router-dom'
import RightImage from './RightImage'
import NotFoundImage from './NotFoundImage'

const NotFound = () => {
  const navigate = useNavigate();
  const [buttonText, setButtonText] = React.useState('');
  const token = localStorage.getItem('token');
  useEffect(() => {
    token ? setButtonText('Dashboard') : setButtonText('Login');
  }, [token]);
  const handleNavigation = () => {
    if (!token) {
      navigate('/login');
    } else {
      navigate('/');
    }
  };
  
  return (
    <Box sx={{ height: '100vh' }}>
      <Box sx={{ position: 'absolute', top: '0.2rem', left: '1em' }}>
        <HumbeeLogo />
      </Box>  
      <Box sx={{ display: 'flex', height: '100vh', justifyContent:'space-around' }}>
        <Box sx={{
          display:'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          paddingX: { xs: '2rem'},
          paddingTop: { xs: '4rem', md: '5rem' },
        }}>
          <Box sx={{ mb: 3 }}>
            <NotFoundImage />
          </Box>
          <Typography variant='h3' sx={{ fontWeight: 'bold', mb:3  }}>Page Not Found</Typography>
          <Typography sx={{ color: '#637381', width: { xs: '100%', md: '75%' } , mb:3 }}>
            Sorry, the page you’re looking for does not exist or has been moved please go back to the {buttonText}
          </Typography>
          <Box>
            <Button onClick={handleNavigation} size='large' variant="contained">
              Go to {buttonText}
            </Button>
          </Box>
        </Box>
        <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center',padding: '2rem' }}>
          <RightImage />
        </Box>
      </Box>
    </Box>
  )
}

export default NotFound